import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { StartFreeHeroInfo } from './start-free/StartFreeHeroInfo';
import { StartFreeHeroForm } from './start-free/StartFreeHeroForm';
import { StartFreeBenefits } from './start-free/StartFreeBenefits';
import { StartFreeIncludes } from './start-free/StartFreeIncludes';
import { StartFreeReviews } from './start-free/StartFreeReviews';
import { StartFreeCoaches } from './start-free/StartFreeCoaches';
import { StartFreeFAQHeader } from './start-free/StartFreeFAQHeader';
import { StartFreeFAQQuestions } from './start-free/StartFreeFAQQuestions';
import { StartFreeFinalCTA } from './start-free/StartFreeFinalCTA';
export function StartFree() {
  useEffect(() => {
    document.title = 'Try Storm Taekwondo Free | Build Confidence & Focus';
    // Canonical to /SignMeUp — StartFree is a paid-social variant of the
    // primary trial-class conversion page and should not compete in organic SEO.
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = `${window.location.origin}/SignMeUp`;
    let robots = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    if (!robots) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      document.head.appendChild(robots);
    }
    robots.content = 'noindex, follow';
    return () => {
      // Leave canonical/robots as-is on navigation — Home/other pages can
      // overwrite them in their own effects.
    };
  }, []);
  return <div className="flex flex-col" data-id="element-3108">
      <section className="relative min-h-[80vh] flex items-center pt-20 pb-24 overflow-hidden" data-id="element-3109">
        <div className="absolute inset-0" data-id="element-3110">
          <img src="https://images.unsplash.com/photo-1591117207239-788bf8de6c3b?auto=format&fit=crop&w=2000&q=80" alt="Kids smiling in martial arts class" className="block w-full h-full object-cover" data-id="element-3111" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/80 to-transparent" data-id="element-3112" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-3113">
          <div className="max-w-2xl" data-id="element-3114">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-3115">
              <StartFreeHeroInfo data-id="element-3116" />
              <StartFreeHeroForm data-id="element-3117" />
            </motion.div>
          </div>
        </div>
      </section>
      <StartFreeBenefits data-id="element-3118" />
      <StartFreeIncludes data-id="element-3119" />
      <StartFreeReviews data-id="element-3120" />
      <StartFreeCoaches data-id="element-3121" />
      <section className="py-24 bg-off-white" data-id="element-3122">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3123">
          <StartFreeFAQHeader data-id="element-3124" />
          <StartFreeFAQQuestions data-id="element-3125" />
        </div>
      </section>
      <StartFreeFinalCTA data-id="element-3126" />
    </div>;
}